import React, { Suspense, lazy } from "react";
const ReactApexChart = lazy(() => import("react-apexcharts"));

const DonutChart = ({ chart_title, chart_data = [], chart_categories = [] }) => {
  const safeData = Array.isArray(chart_data)
    ? chart_data.map((v) => (typeof v === "number" ? v : 0))
    : [];

  const safeLabels = Array.isArray(chart_categories)
    ? chart_categories.map((v) =>
        v !== undefined && v !== null ? v.toString() : ""
      )
    : [];

  const chartOptions = {
    chart: {
      type: "donut",
    },

    labels: safeLabels,

    title: {
      text: chart_title || "",
      align: "center",
    },

    plotOptions: {
      pie: {
        donut: {
          size: "65%", // 👈 donut thickness
        },
      },
    },

    legend: {
      position: "bottom",
      onItemHover: {
        highlightDataSeries: false,
      },
    },

    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 260 },
        },
      },
    ],
  };

  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <Suspense fallback={<div style={{ textAlign: "center" }}>Loading chart...</div>}>
        <ReactApexChart
          options={chartOptions}
          series={safeData}
          type="donut"
          width={380}
          height={340}
        />
      </Suspense>
    </div>
  );
};

export default DonutChart;
